<template>
  <!-- 网站公告 -->
  <div class="home-snowing" v-show="show">
    <div class="chirs-line"></div>
    <canvas id="snow"></canvas>
  </div>
</template>
<script>
  export default {
    name: 'home-snowing',
    data () {
      return {
        show: true
      }
    },
    mounted () {
      if (this.show) this.init()
    },
    methods: {
      init () {
        function sliding (callback, duration) {

          let starttime = Date.now()

          function animate (timestamp) {
            let runtime = timestamp - starttime
            if (runtime < duration) {
              requestAnimationFrame(function () {
                animate(Date.now())
              })
            } else {
              callback()
            }
          }

          requestAnimationFrame(function () {
            animate(Date.now())
          })
        }

        function initSnow () {
          let W = window.innerWidth
          let H = window.innerHeight
          let canvas = document.getElementById('snow')
          canvas.width = W
          canvas.height = H
          let ctx = canvas.getContext('2d')
          let mp = 30
          let particles = []
          for (let i = 0; i < mp; i++) {
            particles.push({
              x: Math.random() * W,
              y: Math.random() * H,
              r: Math.random() * 4 + 1,
              d: Math.random() * mp
            })
          }

          function draw () {
            ctx.clearRect(0, 0, W, H)
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)'
            ctx.beginPath()
            for (let i = 0; i < mp; i++) {
              let p = particles[i]
              ctx.moveTo(p.x, p.y)
              ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2, true)
            }
            ctx.fill()
            update()
            sliding(draw, 10)
          }

          let angle = 0

          function update () {
            angle += 0.01
            for (let i = 0; i < mp; i++) {
              let p = particles[i]
              p.y += 0.5 * Math.cos(angle + p.d) + 0.5 + p.r / 2
              p.x += Math.sin(angle)
              if (p.x > W + 5 || p.x < -5 || p.y > H) {
                if (i % 3 > 0) {
                  particles[i] = {x: Math.random() * W, y: -10, r: p.r, d: p.d}
                } else {
                  if (Math.sin(angle) > 0) {
                    particles[i] = {x: -5, y: Math.random() * H, r: p.r, d: p.d}
                  } else {
                    particles[i] = {x: W + 5, y: Math.random() * H, r: p.r, d: p.d}
                  }
                }
              }
            }
          }

          draw()
        }

        initSnow()
      }
    }
  }
</script>
<style scoped>

  .chirs-line {
    width: 100%;
    height: 1.5rem;
    position: fixed;
    bottom: 1rem;
    background: url(/static/images/chirs-line-0.png) center center no-repeat;
    z-index: 5;
  }

  #snow {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    pointer-events: none;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home-snowing.vue